import { createStoreApi } from './store-api.js';
import { initCartFeedback } from './cart-feedback.js';
import { productQuantityError, sharedProductQuantityLimits, addProductSelection } from './product-selection.js';

// 商品・買い物袋のデザインUIを既存のStore APIに接続する
export function initHomeShop($, { openDialog }) {
  const config = window.ueharaStore;
  const productDialog = document.getElementById('HomeProductDialog');
  const cartDialog = document.getElementById('HomeCartDialog');
  if (!config || !productDialog || !cartDialog) return;
  const store = createStoreApi($, config);
  const $add = $('.js-home-product-add');
  const $addLabel = $add.find('.js-home-product-add-label');
  const $quantity = $('.js-home-product-quantity');
  const $productStatus = $('.js-home-product-status');
  const $productFeedback = $('.js-home-product-feedback');
  const $cartStatus = $('.js-home-cart-status');
  const cartFeedback = initCartFeedback($, cartDialog, plain);
  const productsById = new Map();
  const currencyFormats = new Map();
  const $catalog = $('.js-home-products-grid');
  const $catalogStatus = $('.js-home-products-status');
  const $catalogRetry = $('.js-home-products-retry');
  let nextPage = 1;
  let productOptions = [];
  let requestId = 0;
  let busy = false;
  let cart = null;
  let productAdded = false;

  // APIのHTMLは文字列に戻し、URLもHTTP(S)だけを画像として表示する
  function plain(value) {
    return new DOMParser().parseFromString(String(value || ''), 'text/html').body.textContent || '';
  }
  function money(amount, prices) {
    if (!currencyFormats.has(prices.currency_code)) currencyFormats.set(prices.currency_code, new Intl.NumberFormat('ja-JP', { style: 'currency', currency: prices.currency_code }));
    return currencyFormats.get(prices.currency_code).format(Number(amount) / 10 ** prices.currency_minor_unit);
  }
  function price(product) {
    if (!product.prices || product.prices.price === '') return '価格未設定';
    const prices = product.prices;
    const range = prices.price_range;
    return '［税込］' + money(range ? range.min_amount : prices.price, prices) + (range && range.min_amount !== range.max_amount ? '〜' : '') + ' / 1kg';
  }
  function message($element, text, error = false) {
    $element.text(text).toggleClass('is-error', error);
  }
  function errorMessage(xhr, mutation = false) {
    if (xhr.status === 0) return mutation ? '更新結果を確認できませんでした。再操作する前に買い物袋を再読み込みして内容を確認してください。' : '通信結果を確認できませんでした。時間をおいて再読み込みしてください。';
    return plain(xhr.responseJSON?.message) || '読み込みに失敗しました。もう一度お試しください。';
  }
  function safeImage(src) {
    try { const url = new URL(src, window.location.href); return ['http:', 'https:'].includes(url.protocol) ? url.href : ''; } catch { return ''; }
  }

  // 商品画像は管理画面の登録値だけを表示し、未登録・読込失敗時は代替テキストを出す
  function renderProductImage($container, product, lazy = false) {
    $container.empty().removeClass('is-loaded').text('商品画像未登録');
    const image = product?.images?.[0];
    const src = image && safeImage(image.src);
    if (!src) return;
    $container.empty().addClass('is-loaded');
    $('<img>', { src, alt: image.alt || plain(product.name), loading: lazy ? 'lazy' : 'eager' })
      .attr({ width: 720, height: 512, decoding: 'async', srcset: image.srcset || null,
        sizes: lazy ? '(max-width: 639px) calc((100vw - 55px) / 2), (max-width: 767px) 293px, (max-width: 1177px) calc((100vw - 98px) / 3), 360px' : '(max-width: 767px) calc(100vw - 32px), 560px' })
      .one('error', function () { $container.empty().removeClass('is-loaded').text('商品画像を表示できません。'); })
      .appendTo($container);
  }

  // チェックした種別に共通の数量を使い、各商品のAPI制約を満たす範囲にする
  function updateProductSelection(resetQuantity = false) {
    const selected = productOptions.filter(entry => entry.available && entry.input.checked);
    const limits = sharedProductQuantityLimits(selected.map(entry => entry.product.add_to_cart || {}));
    $quantity.attr({ min: limits.minimum, step: limits.multiple_of });
    $quantity.attr('max', limits.maximum > 0 ? limits.maximum : null);
    if (resetQuantity && productQuantityError($quantity[0].valueAsNumber, limits)) $quantity.val(limits.minimum);
    const error = limits.valid ? productQuantityError($quantity[0].valueAsNumber, limits) : '選択した種別で共通の数量を指定できません。種別を選び直してください。';
    $quantity[0].setCustomValidity(error);
    $quantity.attr('aria-invalid', String(Boolean(error)));
    $('.js-home-product-quantity-error').text(error);
    // 追加完了後は同じボタンから買い物袋を開き、二重追加を防ぐ。
    $addLabel.text(productAdded ? '買い物袋を確認する' : '買い物袋に追加');
    $add.attr('aria-haspopup', productAdded ? 'dialog' : null);
    $add.attr('aria-controls', productAdded ? 'HomeCartDialog' : null);
    $add.prop('disabled', busy || (!productAdded && (!selected.length || Boolean(error))));
  }
  $quantity.on('input change', function () { productAdded = false; message($productFeedback, ''); updateProductSelection(); });
  function setBusy(value) {
    busy = value;
    $(document).trigger('uehara:cart-busy', [value]);
    cartFeedback.setBusy(value);
    $(cartDialog).add(productDialog).attr('aria-busy', String(value));
    $(cartDialog).find('input').prop('readOnly', value);
    $(cartDialog).find('button:not(.js-home-dialog-close):not(.js-home-dialog-open):not(.js-home-cart-login)').attr('aria-disabled', String(value));
    $(productDialog).find('input, .js-home-step').prop('disabled', value);
    productOptions.forEach(function (entry) {
      if (!entry.available) $(entry.input).prop('disabled', true);
    });
    updateProductSelection();
  }
  function option(product, label) {
    const available = product.is_in_stock && product.is_purchasable;
    const $row = $('<label>', { class: 'p-home-option' }).toggleClass('is-unavailable', !available);
    const $input = $('<input>', { type: 'checkbox', class: 'p-home-option__input', value: product.id, disabled: !available }).appendTo($row);
    const $body = $('<span>', { class: 'p-home-option__body' }).appendTo($row);
    $('<span>', { text: label }).appendTo($body);
    $('<span>', { class: 'p-home-option__stock', text: available ? '在庫あり' : '在庫切れ・販売停止' }).toggleClass('is-available', available).appendTo($body);
    $('<strong>', { class: 'p-home-option__price', text: price(product) }).appendTo($row);
    productOptions.push({ product, available, input: $input[0] });
    $input.on('change', function () { productAdded = false; message($productStatus, ''); message($productFeedback, ''); updateProductSelection(true); });
    return $row;
  }

  // 公開APIで取得できた商品のみ、IDを使って一覧と詳細へ接続する
  function renderProductCard(product) {
    const $card = $('<article>', { class: 'p-home-product js-home-reveal' });
    const $media = $('<div>', { class: 'p-home-product__media' }).appendTo($card);
    renderProductImage($media, product, true);
    const $title = $('<h3>').appendTo($card);
    $('<button>', { class: 'p-home-product__button js-home-product-open', type: 'button', text: plain(product.name), 'data-product-id': product.id, 'aria-haspopup': 'dialog' }).appendTo($title);
    $('<p>', { text: price(product) }).appendTo($card);
    return $card[0];
  }
  function loadProducts() {
    const page = nextPage;
    $catalog.attr('aria-busy', 'true');
    $catalogRetry.prop('hidden', true);
    message($catalogStatus, '商品を読み込んでいます。');
    store.products(page).done(function (products, _status, xhr) {
      const cards = document.createDocumentFragment();
      products.forEach(function (product) {
        if (productsById.has(product.id)) return;
        productsById.set(product.id, product);
        cards.appendChild(renderProductCard(product));
      });
      $catalog.append(cards);
      $(document).trigger('home:content-updated');
      if (page < Number(xhr.getResponseHeader('X-WP-TotalPages'))) { nextPage = page + 1; loadProducts(); }
      else {
        $catalog.attr('aria-busy', 'false');
        message($catalogStatus, productsById.size ? '' : '現在、掲載商品はありません。');
      }
    }).fail(function (xhr) {
      $catalog.attr('aria-busy', 'false');
      message($catalogStatus, errorMessage(xhr), true);
      $catalogRetry.prop('hidden', false);
    });
  }
  $catalogRetry.on('click', loadProducts);
  $catalog.on('click', '.js-home-product-open', function () {
    const id = ++requestId;
    const product = productsById.get(Number(this.dataset.productId));
    if (!product) return;
    productAdded = false;
    productOptions = [];
    $quantity.val(1);
    message($productFeedback, '');
    updateProductSelection();
    $('#HomeProductTitle').text(plain(product.name));
    $('.js-home-product-description').text(plain(product.description));
    renderProductImage($('.js-home-product-image'), product);
    const $options = $('.js-home-product-variations').empty();
    openDialog(productDialog, this);
    message($productStatus, '商品を読み込んでいます。');
    // 一覧の親商品を先に表示し、可変商品は価格・在庫を種別APIで更新する
    const detailRequest = product.type === 'variable' ? store.variations(product.id) : store.product(product.id);
    detailRequest.done(function (detail) {
      if (id !== requestId || !productDialog.open) return;
      if (product.type === 'variable') {
        detail.forEach(function (variation) { $options.append(option(variation, plain(variation.variation || variation.name).replace(/^商品種別[:：]\s*/, ''))); });
        updateProductSelection();
        message($productStatus, detail.length ? '' : '選択可能な商品種別がありません。');
      } else if (detail.type === 'simple') {
        $('.js-home-product-description').text(plain(detail.description));
        $options.append(option(detail, plain(detail.name)));
        $options.find('input').prop('checked', true);
        updateProductSelection(true);
        message($productStatus, detail.is_in_stock && detail.is_purchasable ? '' : '現在この商品は購入できません。');
      } else message($productStatus, 'この商品タイプは担当者への確認が必要です。');
    }).fail(function (xhr) { if (id === requestId && productDialog.open) message($productStatus, errorMessage(xhr), true); });
  });

  // 商品とカートの数量操作を共通化し、整数・最小値・最大値をネイティブ入力で検証する
  $(document).on('click', '.js-home-step', function () {
    if (busy) return;
    const input = this.closest('.p-home-stepper').querySelector('input');
    if (input.disabled) return;
    if (Number(this.dataset.step) > 0) input.stepUp(); else input.stepDown();
    $(input).trigger('change');
  });

  // 変更された商品行だけを作り直し、他の行のDOMと操作位置を保つ
  function renderCartRow(item) {
    const $row = $('<article>', { class: 'p-home-cart__item', 'data-key': item.key });
    const $body = $('<div>', { class: 'p-home-cart__body' }).appendTo($row);
    const $name = $('<h3>', { class: 'p-home-cart__name', text: plain(item.name) }).appendTo($body);
    (item.variation || []).forEach(function (variation) { $('<span>', { class: 'p-home-cart__variation', text: plain(variation.value) }).appendTo($name); });
    const itemLabel = [plain(item.name), ...(item.variation || []).map(variation => plain(variation.value))].join(' ');
    $('<p>', { class: 'p-home-cart__price', text: '［税込］' + money(item.prices.price, item.prices) + ' / 1kg' }).appendTo($body);
    $('<p>', { class: 'p-home-cart__amount', text: money(Number(item.totals.line_total) + Number(item.totals.line_total_tax), item.totals) }).appendTo($row);
    const $controls = $('<div>', { class: 'p-home-cart__controls' }).appendTo($row);
    const $stepper = $('<div>', { class: 'p-home-stepper' }).appendTo($controls);
    const limits = item.quantity_limits;
    $('<button>', { class: 'js-home-step', type: 'button', 'data-step': -1, text: '−', 'aria-label': itemLabel + 'の数量を減らす', disabled: !limits.editable }).appendTo($stepper);
    $('<input>', { class: 'js-home-cart-quantity', type: 'number', min: limits.minimum, max: limits.maximum, step: limits.multiple_of, value: item.quantity, 'data-key': item.key, 'aria-label': itemLabel + 'の数量（kg）', 'data-uneditable': !limits.editable ? 'true' : null, disabled: !limits.editable, required: true }).appendTo($stepper);
    $('<button>', { class: 'js-home-step', type: 'button', 'data-step': 1, text: '＋', 'aria-label': itemLabel + 'の数量を増やす', disabled: !limits.editable }).appendTo($stepper);
    const $remove = $('<button>', { class: 'p-home-cart__remove js-home-cart-remove', type: 'button', 'data-key': item.key, 'aria-label': itemLabel + 'を買い物袋から削除' }).appendTo($controls);
    $remove.append(document.getElementById('HomeCartRemoveIcon').content.cloneNode(true));
    $('<span>', { text: '削除' }).appendTo($remove);
    return $row[0];
  }
  function renderCart(nextCart) {
    const focused = document.activeElement;
    const focusedKey = focused?.dataset.key || focused?.closest('.p-home-stepper')?.querySelector('input')?.dataset.key;
    const focusedStep = focused?.matches('.js-home-step') ? focused.dataset.step : null;
    const previousItems = new Map((cart?.items || []).map(item => [item.key, item]));
    const items = document.querySelector('.js-home-cart-items');
    const rows = new Map(Array.from(items.children).map(row => [row.dataset.key, row]));
    cart = nextCart;
    cartFeedback.render(cart);
    $(document).trigger('uehara:cart-updated', [cart]);
    $('.js-home-cart-count').text(cart.items_count);
    cart.items.forEach(function (item, index) {
      let row = rows.get(item.key);
      if (!row || JSON.stringify(previousItems.get(item.key)) !== JSON.stringify(item)) {
        const nextRow = renderCartRow(item);
        if (row) row.replaceWith(nextRow);
        row = nextRow;
      }
      row.querySelector('.js-home-cart-quantity').value = item.quantity;
      if (items.children[index] !== row) items.insertBefore(row, items.children[index] || null);
      rows.delete(item.key);
    });
    rows.forEach(row => row.remove());
    $('.js-home-cart-head, .js-home-cart-summary').prop('hidden', !cart.items.length);
    $(cartDialog).find('.p-home-cart').prop('hidden', !cart.items.length);
    $('.js-home-cart-subtotal').text(money(cart.totals.total_items, cart.totals));
    $('.js-home-cart-tax').text(money(cart.totals.total_tax, cart.totals));
    $('.js-home-cart-total').text(money(cart.totals.total_price, cart.totals));
    message($cartStatus, cart.items.length ? '' : '買い物袋に商品が入っていません。');
    $('.js-home-cart-retry').prop('hidden', true);
    if (focusedKey && cartDialog.open) {
      const selector = focused.matches('.js-home-cart-remove') ? '.js-home-cart-remove' : '.js-home-cart-quantity';
      let next = Array.from(cartDialog.querySelectorAll(selector)).find(element => element.dataset.key === focusedKey);
      if (focusedStep && next) next = next.closest('.p-home-stepper').querySelector('button[data-step="' + focusedStep + '"]');
      next = next || cartDialog.querySelector('.js-home-dialog-close');
      // 通信完了時にdisabledが外れてから、同じキーの要素へ戻す
      window.requestAnimationFrame(function () { if (next && next !== document.activeElement) next.focus({ preventScroll: true }); });
    }
  }
  function cartFailure(xhr, mutation = true) {
    if (xhr.responseJSON?.data?.cart) renderCart(xhr.responseJSON.data.cart);
    cartFeedback.fail();
    $(document).trigger('uehara:cart-failed');
    message($cartStatus, errorMessage(xhr, mutation), true);
    $('.js-home-cart-retry').prop('hidden', false);
  }
  function loadCart() {
    if (busy || !config.available) return;
    setBusy(true);
    message($cartStatus, '買い物袋を読み込んでいます。');
    store.cart().done(renderCart).fail(function (xhr) { cartFailure(xhr, false); }).always(function () { setBusy(false); });
  }
  $('.js-home-cart-open').on('click', function () { openDialog(cartDialog, this); loadCart(); });
  $('.js-home-cart-retry').on('click', loadCart);
  $add.on('click', async function () {
    if (busy || $add.prop('disabled')) return;
    if (productAdded) {
      openDialog(cartDialog, this);
      loadCart();
      return;
    }
    if (!$quantity[0].reportValidity()) return;
    const selection = productOptions.filter(entry => entry.available && entry.input.checked).map(entry => ({ id: entry.product.id, quantity: $quantity[0].valueAsNumber, input: entry.input }));
    if (!selection.length) return;
    const currentRequest = requestId;
    let added = 0;
    let addedCart = null;
    setBusy(true);
    // 追加中・完了の通知はボタン上の余白に表示し、写真と内容の高さを変えない
    message($productStatus, '');
    message($productFeedback, '買い物袋に追加しています。');
    try {
      await addProductSelection(selection, store.add, function (entry, nextCart) {
        added += 1;
        entry.input.checked = false;
        addedCart = nextCart;
      });
      if (addedCart) renderCart(addedCart);
      if (currentRequest === requestId) {
        productAdded = true;
        message($productFeedback, '買い物袋に追加しました。');
      }
    } catch (xhr) {
      if (addedCart && !xhr.responseJSON?.data?.cart) renderCart(addedCart);
      cartFailure(xhr);
      if (currentRequest === requestId) {
        message($productFeedback, '');
        message($productStatus, (added ? added + '種別を追加済みです。' : '') + errorMessage(xhr, true), true);
      }
    } finally {
      setBusy(false);
    }
  });
  $('.js-home-cart-items').on('change', '.js-home-cart-quantity', function () {
    if (busy) return;
    if (!this.reportValidity()) { if (cart) renderCart(cart); return; }
    setBusy(true);
    store.update(this.dataset.key, Number(this.value)).done(renderCart).fail(function (xhr) {
      if (cart) renderCart(cart);
      cartFailure(xhr);
    }).always(function () { setBusy(false); });
  }).on('click', '.js-home-cart-remove', function () {
    if (busy) return;
    setBusy(true);
    store.remove(this.dataset.key).done(renderCart).fail(cartFailure).always(function () { setBusy(false); });
  });
  if (config.available) {
    if ($catalog.length) loadProducts();
    loadCart();
  }
  else {
    $catalog.attr('aria-busy', 'false');
    message($catalogStatus, '商品情報は準備中です。');
    message($cartStatus, 'WooCommerceが未設定のため買い物袋を読み込めません。', true);
  }
}
